<template>
  <div class="flex w-full gap-3">
    <span v-if="!sentByMe" class="pt-2">
      <ui-server-img
        :src="avatar_url ?? '/guest.webp'"
        class="!w-8 rounded-full"
        :class="{
          '!invisible': isLastSameSender,
        }"
        />
    </span>
    <div class="flex flex-col w-full">
      <div
        class="p-3 rounded-xl text-fakeblack shadow-lg shadow-slate-200 whitespace-pre-line max-w-[80%]"
        :class="{
          'bg-gray-300/70 self-start !rounded-bl-none':!sentByMe,
          'bg-white/70 self-end !rounded-br-none':sentByMe,
        }"
        v-html="message"
        />

      <div
        v-if="!isNextSameSender"
        class="text-xs text-fakeblack/50 mt-1 line-clamp-1 max-w-[80%]"
        :class="{
          'self-start !rounded-bl-none':!sentByMe,
          'self-end !rounded-br-none':sentByMe,
        }"
        >
        <span
          v-text="moment(createdAt).format('HH:mm')"
          />

        <span
          v-if="!sentByMe"
          :title="sendername"
          v-text="' - '+sendername"
          />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import moment from 'moment'

const {
  avatar_url,
  sentByMe,
  message,
  createdAt,
  isLastSameSender
} = defineProps<{
  message?: string,
  sentByMe?: boolean,
  createdAt?: string
  avatar_url?: string
  sendername?: string
  isLastSameSender: boolean
  isNextSameSender: boolean
}>()
</script>
